var updateFooterMarketLinkHref = function(link) {
  var href = link.getAttribute('href');

  if (!href) return;

  var nextUrl = new URL(href, window.location.origin);

  nextUrl.search = window.location.search;
  nextUrl.hash = window.location.hash;

  link.setAttribute('href', nextUrl.pathname + nextUrl.search + nextUrl.hash);
};

var initFooterMarketLinks = function() {
  var marketLinks = document.querySelectorAll('.js-footer-market-link');

  if (!marketLinks.length) return;

  marketLinks.forEach(function(link) {
    updateFooterMarketLinkHref(link);

    link.addEventListener('click', function() {
      updateFooterMarketLinkHref(link);
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFooterMarketLinks);
} else {
  initFooterMarketLinks();
}